export type Purchase = {
  name: string
  city: string
  state: string
}

/**
 * Real recent orders only (e.g. pulled from the store). While the list is
 * empty the purchase notification stays hidden.
 */
export const recentPurchases: Purchase[] = []
